import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.ListItemFilters, {
        attrs: {
          icon: "ui-icon-plus",
          title:
            _setup.doctorFiltersState.otherSpeciality?.name ||
            _setup.t("Дополнительная специальность", _setup.options),
          subtitle: _setup.doctorFiltersState.otherSpeciality
            ? _setup.t("Дополнительная специальность", _setup.options)
            : "",
        },
        on: { click: _setup.openDialog },
      }),
      _vm._v(" "),
      _c(_setup.SpecialityModal, {
        attrs: {
          value: _setup.isDialogOpened,
          "is-back": "",
          title: _setup.t("Доп. специальность", _setup.options),
          placeholder: _setup.t("Специальность", _setup.options),
          "title-truncate": "",
          "is-visible-reset": "",
          "town-id": _setup.commonStore.town.id,
          "town-translit": _setup.commonStore.town.translit,
          "is-doctor-list-home":
            _setup.doctorFiltersState.visitLocation === "home",
          "is-doctor-list-online":
            _setup.doctorFiltersState.visitLocation === "online",
          "selected-speciality":
            _setup.filtersStore.unsavedFilters.otherSpeciality,
          "excluded-speciality": _setup.doctorFiltersState.speciality,
          "patient-age": _setup.doctorFiltersState.patientAge,
        },
        on: {
          "speciality:selected": _setup.onClickSpeciality,
          "speciality:reset": _setup.onResetSpeciality,
          input: _setup.handleCloseSpecialityModal,
        },
        scopedSlots: _vm._u([
          {
            key: "footer",
            fn: function ({ selectedSpeciality }) {
              return [
                _c(
                  "div",
                  { staticClass: "pa-2 elevation-8" },
                  [
                    _c(
                      VBtn,
                      {
                        attrs: {
                          block: "",
                          depressed: "",
                          color: "primary",
                          disabled: !_setup.hasUnsavedSpeciality,
                        },
                        on: {
                          click: function ($event) {
                            return _setup.handleSpecialitySelected(
                              selectedSpeciality
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.t("Применить", _setup.options)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }